import React, { useEffect, useRef } from "react";
import { Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';

import '../../css/main.css';

// loading = mazanie práve beží: tlačidlá neaktívne, „Mažem…“ so spinnerom, okno sa nedá zavrieť.
// question / warning / confirmLabel / loadingLabel = vlastné texty (napr. deaktivácia namiesto mazania).
const ConfirmDeleteModal = ({
    open, onClose, onNo, onYes, item, note, loading = false,
    question, warning, confirmLabel, loadingLabel,
}) => {

    const [t, ] = useTranslation('global');
    const deleteButtonRef = useRef(null);

    useEffect(() => {
        if (open) {
            setTimeout(() => deleteButtonRef.current?.focus(), 50);
        }
    }, [open]);

    return (
        <div className="confirm-del-wrapper">
        <Modal
            open={open}
            onClose={loading ? undefined : onClose}
            aria-labelledby="confirm-del-modal-title"
            aria-describedby="confirm-del-modal-desc"
        >
            <div className="confirm-del-modal-container">
                <h2 id="confirm-del-modal-title">{t('areYouSure')}</h2>
                <div id="confirm-del-modal-desc">
                    <p>{question || t('doYouReallyWantToDelete')} <strong className="confirm-del-item">{item}</strong>?</p>
                    <p>{warning || t('cannotBeUndone')}</p>
                    {note && <p className="confirm-del-note">{note}</p>}
                </div>

                <div className="confirm-del-buttons">
                    <button className="confirm-cancel-button" onClick={onNo} disabled={loading}>{t('cancel')}</button>
                    <button ref={deleteButtonRef} className="confirm-delete-button" onClick={onYes} disabled={loading}>
                        {loading
                            ? <><span className="btn-spinner" aria-hidden="true" />{loadingLabel || t('deleting')}</>
                            : (confirmLabel || t('delete'))}
                    </button>
                </div>

            </div>
        </Modal>
        </div>

    );
}

export default ConfirmDeleteModal;